import styled from 'styled-components';
import { Card } from '@material-ui/core';

export default styled(Card)`
  border-radius: ${props => props.theme.borderRadius.large};
  border: 1px solid ${props => props.theme.colors.border.default};
  box-shadow: none;
`;
